import PrevNextBtns from '@/components/calculators/components/PrevNextBtns';
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Mm100Page } from '../../index';
import css from './index.module.scss';
export const scenes = [
    { key: 'rv', img: '/img/calculators/mm100/step1-rv.jpg', i18n: 'rv' },
    { key: 'house', img: '/img/calculators/mm100/step1-offGrid.jpg', i18n: 'house' },
    { key: 'others', img: '/img/calculators/mm100/step1-others.jpg', i18n: 'others' },
];

export default function Step1({ data, callBack }: any) {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('shared');
    const [active, setActive] = useState(data?.scene || '');

    useEffect(() => {
        setActive(data?.scene);
    }, [data?.scene]);

    const chooseScene = (key: string) => {
        if (key !== active) {
            if (key === 'others') {
                callBack({ totalStep: 6, stepTitle: [key, ...data.stepTitle.slice(2)], scene: key });
            } else {
                callBack({
                    totalStep: 7,
                    stepTitle: [key, 'type', ...data.stepTitle.slice(-5)],
                    scene: key,
                });
            }
            setActive(key);
        }
    };

    const onNext = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator1',
            step: 'solution',
            product_name: 'Ecoflow Power Kits',
            option_name: active,
            button_name: 'Next',
        });
        callBack({
            scene: active,
            currentStep: data.currentStep + 1,
            currentPage: data?.scene === 'others' ? Mm100Page.Appliances : Mm100Page.Type,
        });
    };

    return (
        <div className={`step1 step ${css.step1}`}>
            <p className="step1-title">{t('calculators.mm100.step1.title')}</p>
            <div className="step1-imgs">
                {scenes.map((scene: any) => (
                    <div
                        className={`step1-img ${active === scene.key ? 'active' : ''}`}
                        key={scene.key}
                        style={{ width: `${100 / scenes?.length}%` }}
                        onClick={() => chooseScene(scene?.key)}
                    >
                        <div className="img-item">
                            <Image
                                src={scene?.img}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step1.${scene.i18n}`)}
                                aria-label={t(`calculators.mm100.step1.${scene.i18n}`)}
                            />
                        </div>
                        <div className="cover"></div>
                        {active === scene.key && (
                            <div className="checkIcon">
                                <Image
                                    src="/img/calculators/mm100/selected.svg"
                                    width={44}
                                    height={44}
                                    className="fullImgs"
                                    alt={t(`calculators.mm100.step1.${scene.i18n}`)}
                                    aria-label={t(`calculators.mm100.step1.${scene.i18n}`)}
                                />
                            </div>
                        )}
                        <p className="sceneTitle">{t(`calculators.mm100.step1.${scene.i18n}`)}</p>
                    </div>
                ))}
            </div>
            <div className="calculatorMm100-btnsArea">
                <PrevNextBtns canPrev={false} canNext={active} onNext={onNext} />
            </div>
        </div>
    );
}
